import React from 'react'
import Footer from '../common/Footer/Footer'
import TopNavBar from '../common/Header/TopNavBar'
import BannerSlides from '../Sections/BannerSlides'
import BatchDetail from '../Batch/Detail/BatchDetail'


const BatchDetailPage = () => {
  return (
    <div className='bgbg'>
    <TopNavBar />
   <BannerSlides />

      <BatchDetail />
    <Footer />
    </div>
  )
}

export default BatchDetailPage